"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = PromiseSet;

function PromiseSet() {
  this.promiseSet = new Set();
}

_extends(PromiseSet.prototype, {
  add: function add(x) {
    return this.addPromise(Promise.resolve(x));
  },

  addPromise: function addPromise(p) {
    var _this = this;

    this.promiseSet.add(p);
    return p.then(function (x) {
      _this.promiseSet["delete"](p);
      return x;
    });
  },

  size: function size() {
    return this.promiseSet.size;
  }
});
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/blocking-queue/lib/promise-set.js
// module id = 967
// module chunks = 2 6